import type { Medialink } from '../../api/medialink';
import { sumUserMaterialMaxScore, type UserMaterial } from '../../api/user-material';

export function computeBundleMaxScore(items: (UserMaterial | Medialink)[]): number {
  return sumUserMaterialMaxScore(
    items.map(item => ('maxScore' in item ? item : { maxScore: item.score?.maximum ?? 0 })),
  );
}
